/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_DescriptionInputs */

const en_settings_collaborators_description = /** @type {(inputs: Settings_Collaborators_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See your collaborator role across your organization.`)
};

/**
* | output |
* | --- |
* | "See your collaborator role across your organization." |
*
* @param {Settings_Collaborators_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_collaborators_description = /** @type {((inputs?: Settings_Collaborators_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_description(inputs)
});